import { z } from 'zod';
import { TransparencyEnum } from '../event/enum';

export type TransparencyKeywordItem = z.infer<
  typeof schemaTransparencyKeywordItem
>;
export const schemaTransparencyKeywordItem = z.object({
  uid: z.string(),
  value: z.string(),
  isInclude: z.boolean(),
  transparency: TransparencyEnum,
});
